<template lang="pug">
  .traceability-contract-create-page
        base-header(:titulo="$t('relatorio_rastreabilidade.messages.traceabilityReport.title')" :voltarPara='true')
        .view-container-wrapper
            .content
                total-volume(ref="totalVolume")
                report-data(ref="reportData")
                search-contract(ref="searchContract")
                added-volume(ref="addedVolume")
                report-list(ref="reportList")
</template>
<script>
export default {
    components: {
        BaseHeader: () => import('@/components/BaseHeader'),
        ReportData: () => import('@/modules/traceability-report/views/components/report-data/index.vue'),
        TotalVolume: () => import('@/modules/traceability-report/views/components/total-volume/index.vue'),
        SearchContract: () => import('@/modules/traceability-report/views/components/search-contract/index.vue'),
        AddedVolume: () => import('@/modules/traceability-report/views/components/added-volume/index.vue'),
        ReportList: () => import('@/modules/traceability-report/views/components/report-list/index.vue')
    }
};
</script>
<style scoped lang="scss">
.traceability-contract-create-page {
    .view-container-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px;
    }
}
</style>
